import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  CircularProgress,
} from '@mui/material';
import axioss from '../../axios';

const localizer = momentLocalizer(moment);

const MyCalendar = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [currentTask, setCurrentTask] = useState({ id: null, task: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTasks = async () => {
      setLoading(true);
      try {
        const response = await axioss.instance.get(
          `GetAllCalendertaskdata/${sessionStorage.getItem('Customer_Log')}`,
        );
        setTasks(response.data);
      } catch (error) {
        console.error('Error fetching tasks:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, []);

  const handleSelect = ({ start }) => {
    const offset = start.getTimezoneOffset();
    const localDate = new Date(start.getTime() - offset * 60 * 1000);
    const formattedDate = localDate.toISOString().split('T')[0];

    setSelectedDate(formattedDate);
    setCurrentTask({ id: null, task: '' });
    setShowDialog(true);
  };

  const handleClose = () => {
    setShowDialog(false);
    setCurrentTask({ id: null, task: '' });
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      if (currentTask.id !== null) {
        await axioss.instance.put(`UpdateCalenderdata/${currentTask.id}`, {
          Task: currentTask.task,
          Date: selectedDate,
          CustomerID: sessionStorage.getItem('Customer_Log'),
          UserID: 1,
          CreatedBy: 1,
        });
      } else {
        await axioss.instance.post('InsertCalenderdata', {
          Task: currentTask.task,
          Date: selectedDate,
          CustomerID: sessionStorage.getItem('Customer_Log'),
          UserID: 1,
          CreatedBy: 1,
        });
      }
      const response = await axioss.instance.get(
        `GetAllCalendertaskdata/${sessionStorage.getItem('Customer_Log')}`,
      );
      setTasks(response.data);
      handleClose();
    } catch (error) {
      console.error('Error saving task:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = task => {
    setCurrentTask({ id: task.TaskID, task: task.Task });
    setShowDialog(true);
  };

  const handleDelete = async taskId => {
    setLoading(true);
    try {
      await axioss.instance.delete(`DeleteCalenderdata/${taskId}`);
      const response = await axioss.instance.get(
        `GetAllCalendertaskdata/${sessionStorage.getItem('Customer_Log')}`,
      );
      setTasks(response.data);
      handleClose();
    } catch (error) {
      console.error('Error deleting task:', error);
    } finally {
      setLoading(false);
    }
  };

  const events = tasks.map(task => ({
    title: task.Task,
    start: new Date(task.Date),
    end: new Date(task.Date),
    allDay: true,
    id: task.TaskID,
  }));

  return (
    <div className="p-2">
      {loading && <CircularProgress />}
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 500 }}
        selectable
        onSelectSlot={handleSelect}
        onSelectEvent={event =>
          handleEdit(tasks.find(task => task.TaskID === event.id))
        }
      />

      <Dialog open={showDialog} onClose={handleClose}>
        <DialogTitle>
          {currentTask.id !== null ? 'Edit Task' : 'Add Task'}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Task"
            type="text"
            fullWidth
            value={currentTask.task}
            onChange={e =>
              setCurrentTask({ ...currentTask, task: e.target.value })
            }
          />
        </DialogContent>
        <DialogActions>
          {currentTask.id !== null && (
            <Button
              onClick={() => handleDelete(currentTask.id)}
              color="secondary"
            >
              Delete
            </Button>
          )}
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          {currentTask.id !== null ? (
            <Button onClick={handleSave} color="primary">
              Update
            </Button>
          ) : (
            <Button onClick={handleSave} color="primary">
              Save
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MyCalendar;
